import { onMounted } from 'vue';
import { useI18n } from 'vue-i18n';
import psHttp from '@patsnap/common-ps-http';
import {
    createCreditsChargeSdk,
    type CreditsChargeLocale,
} from '@patsnap/credits-charge';
import { isUserLogin } from '@eureka/utils/account'
import { isCNRegion } from '@eureka/utils/environment';

const CREDITS_CHARGE_LOCALES: readonly CreditsChargeLocale[] = ['cn', 'en', 'jp', 'tw'];

/**
 * 页面挂载完成后检查并领取新用户积分充值。
 */
export function useCreditsCharge(): void {
    const { locale: currentLocale } = useI18n();

    onMounted(async() => {
        try {
            const isLogin = await isUserLogin();
            if (!isLogin || isCNRegion()) return;

            const locale = CREDITS_CHARGE_LOCALES.includes(currentLocale.value as CreditsChargeLocale)
                ? currentLocale.value as CreditsChargeLocale
                : 'en';
            const creditsChargeSdk = createCreditsChargeSdk({
                baseURL: import.meta.env.VITE_EUREKA_SERVICE_URI,
                http: psHttp,
                locale,
            });
            await creditsChargeSdk.checkAndClaim();
        } catch (error) {
            console.warn('Credits charge initialization failed:', error);
        }
    });
}
